export default __webpack_public_path__ + "static/media/contacte-nous.b7a5644a.svg";